export default __webpack_public_path__ + "static/food-d74a03baf0d56fbb2c2e18f6ebfb56d5.png";